import { XLSXFileServiceInterface } from "../interfaces/XLSXFileServiceInterface";
import { XLSXClient } from "../XLSXClient/XLSXClient";

export class XLSXFileService implements XLSXFileServiceInterface {

    client: XLSXClient;

    constructor() {
        this.client = new XLSXClient();
    }

    getDataFromArrayBuffer<T>(buffer: ArrayBuffer, numberOfSheet = 0) {
        const workbook = this.client.readFromBuffer(buffer);
        return this.client.convertSheetToJson<T>(workbook.Sheets[workbook.SheetNames[numberOfSheet]])
    }

    createTemplateFile(fields: string[]) {
        const headerRow = this.getRows(fields, [[]]);
        const workBookForSave = this.client.getBookFromJSON(headerRow)
        const arrayBuffer = this.client.getArrayBufferFromBook(workBookForSave);

        return this.saveByteArray("KEKTABLE", arrayBuffer);
    }

    getFileFromData(name: string, data: Record<string, string | number>[]) {
        const workBookForSave = this.client.getBookFromJSON(data);
        const arrayBuffer = this.client.getArrayBufferFromBook(workBookForSave);
        return this.saveByteArray(name, arrayBuffer);
    }

    /**
     * revoking created file object
     * @param url
     */
    revokeFileObject(url: string) {
        window.URL.revokeObjectURL(url);
    }

    private getRows(fields: string[], rows: string[][]) {
        return rows.map((values) => {
            const object: Record<string, string> = {};

            fields.forEach((key, index) => {
                object[key] = values[index]
            })

            return object
        })
    }

    private saveByteArray(reportName: string, byte: ArrayBuffer, needClick = false) {
        let blob = new Blob([byte], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = reportName;
        link.download = fileName;
        needClick && link.click();

        return link.href
    }
}